import { useEffect } from "react";

import { ArrowLeftIcon, CreditCardIcon, ListChecksIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import useIsActive from "hooks/useIsActive";

import { BILLING_CYCLES, ROUTES } from "utils/constants";

import Button from "components/Button";
import Container from "components/Container";
import Content from "components/Content";
import Header from "components/Header";
import MainMenu from "components/MainMenu";

import { useSubscriptionContext } from "context/Subscription";

import { formatDate } from "../../utils/date";

export default function Subscription() {
  const { subscription, isSubscriptionLoading, refetch } = useSubscriptionContext();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useIsActive();

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <>
      <Header className="justify-between">
        <div className="flex items-center gap-2">
          <Link to={ROUTES.HOME} className="flex items-center cursor-pointer">
            <ArrowLeftIcon />
          </Link>
          {t("menu.subscriptions")}
        </div>
        <MainMenu />
      </Header>

      <Content isLoading={isSubscriptionLoading}>
        {subscription && (
          <Container className="flex flex-col gap-6 py-6 px-4">
            <div className="flex flex-col gap-4">
              <div>{t("subscription.mySubscription")}</div>
              <div className="bg-general-mint-600 p-4 rounded-md flex justify-between">
                <div className="flex gap-3">
                  <div className="rounded-sm bg-general-mint-900 p-3">
                    <CreditCardIcon className="stroke-general-green-800" />
                  </div>
                  <div className="flex flex-col gap-1.5">
                    <div className="text-sm font-medium">{subscription?.package?.packageMetas[0].metadata.name}</div>
                    <div className="text-xs text-general-gray-700">
                      {t("subscription.ends")} {formatDate(subscription?.endDate)}
                    </div>
                  </div>
                </div>

                <div className="text-general-gray-800 font-medium">
                  {subscription?.billingCycleId === BILLING_CYCLES.MONTHLY && subscription.package.pricePerMonth}
                  {subscription?.billingCycleId === BILLING_CYCLES.YEARLY && subscription.package.pricePerYear} KM
                </div>
              </div>

              <Button type="button" className="w-full" onClick={() => navigate(ROUTES.CHECKOUT)} variant="secondary">
                {t("subscription.changePlan")}
              </Button>
            </div>

            <div className="flex flex-col gap-4">
              <div>{t("subscription.usageStatus")}</div>
              <div className="bg-general-mint-600 p-4 rounded-md flex justify-between">
                <div className="flex gap-3">
                  <div className="rounded-sm bg-general-mint-900 p-3">
                    <ListChecksIcon className="stroke-general-green-800" />
                  </div>
                  <div className="flex flex-col gap-1.5">
                    <div className="text-xs text-general-gray-700">{t("subscription.usage")}</div>
                    <div className="text-lg font-medium">
                      {subscription?.numberOfReports} {t("subscription.recordings")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        )}
      </Content>
    </>
  );
}
